"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentsOfferPromotions = PaymentsOfferPromotions;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const admin_context_1 = require("@src/components/pages/admin/admin-context");
const dayjs_1 = __importDefault(require("dayjs"));
const slug_offer_1 = __importDefault(require("shared/slug-offer"));
const elements_1 = require("@src/components/elements");
const FormattedDate_1 = require("@src/components/modules/FormattedDate");
const react_intl_1 = require("react-intl");
const react_styled_1 = require("styled-breakpoints/react-styled");
const styled_breakpoints_1 = require("styled-breakpoints");
const Table_1 = require("@src/components/elements/Table");
function PaymentsOfferPromotions() {
    const intl = (0, react_intl_1.useIntl)();
    const { companyInfo: { companyPaymentOfferPromotions }, myOffers, } = (0, admin_context_1.useAdminContextValue)();
    const isLgOrLowerLayout = (0, react_styled_1.useBreakpoint)((0, styled_breakpoints_1.down)('lg'));
    const paymentsTableScroll = isLgOrLowerLayout ? { x: 1000 } : undefined;
    const companyPaymentOfferPromotionsSortedByCreatedAt = companyPaymentOfferPromotions
        ? [...companyPaymentOfferPromotions].sort((fst, snd) => new Date(fst.createdAt) > new Date(snd.createdAt) ? -1 : 1)
        : [];
    const getOfferTitleById = (offerId) => {
        const { active, notActive } = myOffers;
        const offer = [...active, ...notActive].find(off => off.id === offerId);
        return (offer === null || offer === void 0 ? void 0 : offer.title) || null;
    };
    const activePromotions = companyPaymentOfferPromotionsSortedByCreatedAt.filter(promotion => (0, dayjs_1.default)(promotion.endDate).isAfter((0, dayjs_1.default)()));
    const expiredPromotions = companyPaymentOfferPromotionsSortedByCreatedAt.filter(promotion => (0, dayjs_1.default)(promotion.endDate).isSameOrBefore((0, dayjs_1.default)()));
    const promotionsWithSections = (0, Table_1.createTableSections)({
        'admin.payments.offer_promotions.active_promotions': activePromotions,
        'admin.payments.offer_promotions.expired_promotions': expiredPromotions
    }, 'offer-promotion-section');
    const columns = [
        {
            title: intl.formatMessage({ id: 'admin.payments.offer_promotions.offer' }),
            key: 'offerTitle',
            align: 'center',
            render: (offerPromotion) => {
                const { offerId } = offerPromotion;
                const offerTitle = getOfferTitleById(offerId);
                if (offerTitle) {
                    const offerSlug = new slug_offer_1.default({ suffix: offerId, text: offerTitle });
                    return (0, jsx_runtime_1.jsx)(elements_1.Link, { to: `/ponuka/${offerSlug.result}`, children: offerTitle });
                }
                return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.payments.offer_promotions.offer_was_deleted" });
            },
        },
        {
            title: intl.formatMessage({ id: 'admin.payments.offer_promotions.promoted_from' }),
            key: 'startDate',
            align: 'center',
            dataIndex: 'startDate',
            render: (startDate) => {
                return (0, jsx_runtime_1.jsx)(FormattedDate_1.FormattedDate, { value: startDate, day: "numeric", month: "numeric", year: "numeric" });
            },
        },
        {
            title: intl.formatMessage({ id: 'admin.payments.offer_promotions.promoted_to' }),
            key: 'endDate',
            align: 'center',
            dataIndex: 'endDate',
            render: (endDate) => {
                return (0, jsx_runtime_1.jsx)(FormattedDate_1.FormattedDate, { value: endDate, day: "numeric", month: "numeric", year: "numeric" });
            },
        },
        {
            title: intl.formatMessage({ id: 'admin.payments.offer_promotions.day_count' }),
            key: 'dayCount',
            align: 'center',
            render: (offerPromotion) => {
                const { endDate } = offerPromotion;
                const remainingDays = Math.ceil(dayjs_1.default.duration((0, dayjs_1.default)(endDate).diff((0, dayjs_1.default)())).asDays());
                if (remainingDays > 0) {
                    const remainingPart = intl.formatMessage({
                        id: 'general.day.pluralized',
                    }, { count: remainingDays });
                    return remainingPart;
                }
                return '';
            },
        },
    ];
    return ((0, jsx_runtime_1.jsx)(elements_1.Table, { enableSections: true, columns: columns, dataSource: promotionsWithSections, scroll: paymentsTableScroll, pagination: false, rowKey: "id" }));
}
